import { getPopularServices, OIL_CHANGE } from "../../../v1/actions/services"
import Notifications from "../../../v1/components/Notifications"
import { serviceSelectedEvents } from "../../../shared_component/utils/googleAnalyticsHelpers"
import { updateCart } from "../../../v1/actions/user"

export const AddOilChangeService = async ({ store, vehicle, setIsSubmitting, t, cart }) => {
  setIsSubmitting(true)
  const oilService = cart?.order_services?.find((service) => service.reference_id === OIL_CHANGE)
  let services = oilService ? [oilService] : []

  const cartHasOilChange = services.length > 0

  if (!cartHasOilChange) {
    services = await store.dispatch(getPopularServices({ vehicle_id: vehicle.id || null }))
  }

  if (services !== null && services.length) {
    setIsSubmitting(false)
    let newServices =
      cart?.order_services?.reduce((acc, service) => {
        if (service.reference_id === OIL_CHANGE) {
          return acc
        }
        return acc.concat({
          service_definition_id: service.service_definition_id,
          event: "removed"
        })
      }, []) || []

    if (!cartHasOilChange) {
      const service = services.find((service) => service.reference_id === "oil_change")
      newServices.push({
        service_definition_id: service.service_id || service.id || service.service_definition_id,
        event: "added",
        prepaid: service.prepaid,
        position: vehicle.oil_type_name || ""
      })
    }
    return await addService(newServices, setIsSubmitting, vehicle, store, cart, t)
  } else {
    setIsSubmitting(false)
    store.dispatch(
      Notifications.error({
        title: t("errorLbl"),
        message: "Something went wrong",
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    )
    return false
  }
}

const addService = async (services, setIsSubmitting, vehicle, store, cart, t) => {
  setIsSubmitting(true)

  let opts = {
    successCallback: async (cart) => {
      cart.order_services.forEach((service) => {
        serviceSelectedEvents({
          serviceDefinition: service,
          position: service.position,
          vehicle
        })
      })
    }
  }

  try {
    await store.dispatch(updateCart(services, cart.vehicle_id, null, undefined, opts))
    setIsSubmitting(false)
    return true
  } catch (error) {
    setIsSubmitting(false)
    store.dispatch(
      Notifications.error({
        title: t("errorLbl"),
        message: error.toString(),
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    )
    return false
  }
}
